function labelFade(items) {
  $(items)
    .on("keydown keyup change", function() {
      var $field = $(this),
        $parent = $field.parent(),
        $label = $field.prev("label");

      if ($label.length) {
        $parent.toggleClass("form-show-label", Boolean($field.val().length));
      }
    })
    .each(function() {
      var $field = $(this),
        $parent = $field.parent(),
        $label = $field.prev("label");

      if ($label.length) {
        $parent.toggleClass("form-show-label", Boolean($field.val().length));
      }
    });
}

module.exports = {
  labelFade
};



// WEBPACK FOOTER //
// ../assets/js/labels.js